import styled from 'styled-components';

export const ApplicationFormContainer = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 960px;
  margin: 20px auto;
  justify-content: center;
`;
